import React, { useEffect, useState } from "react";
import './css/IPOSummary.css';


const SummaryTable = ({
    nextStep,
    prevStep,
    ipoDetail,
    summaryData
}) => {
 
    const bidDetails = summaryData.summarydataname;
    const [bidTAbledetails, setbidTAbledetails] = useState(summaryData?.summarydataname?.bid_details || summaryData?.summarydataname?.BidingDetails?.bids || []);
    // let bidTAbledetails = bidDetails.Indetails.APIList.bid_details;
    // let biddetails = bidDetails.Indetails;
 
    useEffect(() => {
        console.log(bidTAbledetails)
        console.log(summaryData)
        if(bidTAbledetails){
            bidTAbledetails.forEach((index) => {
                index.showcollapse = false;
               
            })
        }
      
        
    },[]);
   
    

    const stepBack = () => {
        prevStep();
    }
    const [shobiddetails, setshobiddetails] = useState('');
    const openCollapse = (that, index) => {
      
        // let localData = that;
       
        // setshobiddetails(localData);
        let itemsOld = that;
        itemsOld.showcollapse = !itemsOld.showcollapse;

        let items = [...bidTAbledetails];
        let item = { ...items[index] };
        item = itemsOld;
        items[index] = item;


        setbidTAbledetails(items);

    }
    return (
        <>
         {
           bidTAbledetails && bidTAbledetails.length>0  &&

            <>
      
            <div className="summaryTableDiv">
                {
                    bidDetails  &&

                    <table className="tableSummary makeboxborder">
                        <thead>
                            <tr>
                                <th></th>
                                <th>BID 1</th>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <th>BID 2</th>
                                }
                                {
                                    bidTAbledetails.length >= 3 &&
                                    <th>BID 3</th>
                                }

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    IPO Closed
                                </td>
                                

                                <td>
                                    {
                                        bidDetails.BiddingEndDate}
                                </td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>
                                        {bidDetails.BiddingEndDate}
                                    </td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                   
                                        <td>
                                            {bidDetails.bidTAbledetails}

                                        </td>
                                  
                                }


                            </tr>
                            <tr>
                                <td>Price</td>
                                <td>
                                        {bidTAbledetails[0].price}
                                    </td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>
                                        {bidTAbledetails[1].price}
                                    </td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                   
                                        <td>
                                        {bidTAbledetails[2].price}

                                        </td>
                                   
                                }
                            </tr>
                            <tr>
                                <td>Quantity Applied</td>
                                <td>
                                        {bidTAbledetails[0].quantity}
                                    </td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>
                                        {bidTAbledetails[1].quantity}
                                    </td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                   
                                        <td>
                                        {bidTAbledetails[2].quantity}

                                        </td>
                                   
                                }
                            </tr>

                            {/* <tr>
                                <td>Number Shares Allocated</td>
                                <td>
                                       23
                                    </td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>
                                        23
                                    </td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                   
                                        <td>
                                        23

                                        </td>
                                   
                                }
                            </tr> */}
                            
                            <tr>
                                <td>Actual Amount</td>
                                <td>
                                        {bidTAbledetails[0].amount}
                                    </td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>
                                        {bidTAbledetails[1].amount}
                                    </td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                   
                                        <td>
                                        {bidTAbledetails[2].amount}

                                        </td>
                                   
                                }
                            </tr>
                            <tr>
                                <td>Order Id</td>
                                <td> {bidTAbledetails[0].orderid}</td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>  {bidTAbledetails[1].orderid}</td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                    <td> {bidTAbledetails[2].orderid}</td>
                                   
                                }
                            </tr>
                            <tr>
                                <td>Application Status</td>
                              
                                <td>{bidTAbledetails[0].allotment_status}</td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>{bidTAbledetails[1].allotment_status}</td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                    <td>{bidTAbledetails[2].allotment_status}</td>
                                   
                                }
                            </tr>
                            <tr>
                                <td>Allotment Status</td>
                                
                                <td>{bidTAbledetails[0].allotment_status}</td>
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>{bidTAbledetails[1].allotment_status}</td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                    <td>{bidTAbledetails[2].allotment_status}</td>
                                   
                                }
                            </tr>
                            <tr>
                                <td>Rejection Remarks</td>
                                <td>Not Applicable</td>
                               
                                {
                                    bidTAbledetails.length >= 2 &&
                                    <td>Not Applicable</td>
                                }

                                {
                                    bidTAbledetails.length >= 3 &&
                                    <td>Not Applicable</td>
                                   
                                }
                            </tr>

                        </tbody>

                    </table>

                }

            </div>

            {

                    bidDetails  &&   bidTAbledetails.map((item, index) => {
                      
                        return (  
                            <div key={index}>            
                    <div className="collapsecard">
                        <p >BID {index+1}</p>
                        <p className={`down-caret  ${item.showcollapse ? 'opencollapse' : 'closed'}`} onClick={() => openCollapse(item,index)}></p>
                    </div>
                            {
                                item.showcollapse &&
                                <div className="mobTableView">
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">IPO Closed</p>
                                        <p className="mobTabvalue">{
                                             bidDetails.BiddingEndDate.split(",")[0]
                                         }</p>
                                    </div>
                
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Price </p>
                                        <p className="mobTabvalue">{item.price}</p>
                                    </div>
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Quantity Applied</p>
                                        <p className="mobTabvalue">{item.quantity}
                                        </p>
                                    </div>
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Number Shares Allocated</p>
                                        <p className="mobTabvalue">
                                           --
                                            </p>
                                    </div>
                
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Actual Amount</p>
                                        <p className="mobTabvalue">{Number(item.quantity) * Number(item.price)}</p>
                                    </div>
                
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Order Id</p>
                                        <p className="mobTabvalue">#012345</p>
                                    </div>
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Application Status</p>
                                        <p className="mobTabvalue">Applied</p>
                                    </div>
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Allotment Status</p>
                                        <p className="mobTabvalue">Alloted</p>
                                    </div>
                                    <div className="indetailsmobvalue">
                                        <p className="mobLabel">Rejection Remarks</p>
                                        <p className="mobTabvalue">Not Applicable</p>
                                    </div>
                                </div>
                            }
                            </div>
                        );
                    }) 
                }
           
        </>
         }
         </>
    );

}

export default SummaryTable;
